export default {
  dashboard: "لوحة التحكم",
  orders: "الطلبات",
  modified_orders: "الطلبات المعدلة",
  order_issues: "مشاكل الطلبات",
  grn: "استلام البضائع",
  invoices: "الفواتير",
  reviews_ratings: "التقييمات والمراجعات",
  inventory: "المخزون",
  issue_to_kitchen: "إرسال للمطبخ",
  credit_wallet: "المحفظة الائتمانية",
  menu_items: "عناصر القائمة",
  recipe_master: "وصفات الطعام",
  support: "الدعم",
  resreports: "التقارير",
  help: "مساعدة",
  documentation: "التوثيق",
welcome: "مرحبا",
  credit: "الرصيد",
  search_placeholder: "ابحث عن المنتجات أو الطلبات أو الفواتير...",
  shop_now: "تسوق الآن",
};